import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cuándo recibo el material?',
  a: 'Inmediatamente. A los 2 minutos de confirmar el pago te llega un mail con el link de descarga directa.'
}, {
  q: '¿Funciona para mi rubro?',
  a: 'Si vendés servicios como profesional independiente en Argentina, sí. Si cobrás por tu tiempo o conocimiento, el sistema aplica.'
}, {
  q: '¿Y si no me sirve?',
  a: 'Tenés 7 días de garantía total. Si no te sirve, te devolvemos el 100% sin preguntas.'
}, {
  q: '¿En cuánto tiempo veo resultados?',
  a: 'El plan completo es de 30 días, pero si aplicás los mensajes de reactivación hoy, podés tener conversaciones abiertas en 48 horas.'
}, {
  q: '¿Es un curso con videos?',
  a: 'No. Es un PDF táctico de implementación inmediata. Lo leés en una tarde y empezás a aplicar esa misma noche.'
}];
export const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream" data-id="element-90">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-91">
        <div className="text-center mb-16" data-id="element-92">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-93">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-94">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-neutral-200 rounded-xl overflow-hidden shadow-sm" data-id="element-95">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-96">
                <span className="font-bold text-neutral-900 text-lg pr-8 flex items-start gap-3" data-id="element-97">
                  <span className="text-brand-600" data-id="element-98">❓</span> {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-neutral-400 transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-99" />
              </button>
              <AnimatePresence data-id="element-100">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-101">
                    <div className="p-6 pt-0 text-neutral-600 text-lg leading-relaxed border-t border-neutral-100 mt-2" data-id="element-102">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};